module.exports = __webpack_public_path__ + "img/bagCer.050fa02f.png";